<script>
import BaseConfig from '@/plans/MASTER_CLASS/config/base';

export default {
  mixins: [BaseConfig],
  computed: {
    showRemove() {
      return false;
    },
    mx_licenseAlert() {
      if (this.$context.is.mixBuy) {
        return '';
      }

      const depPlan = this.licenseDepPlan;

      return this.selectedNumber >= this.depLicenseQuantity ?
        this.$t('billing.partner.masterclass.goto_billing_page_tips', {
          base: this.$t(depPlan?.planNameKey || depPlan?.typeNameKey),
          addon: this.planTitle,
        }) :
        '';
    },
    increaseTips() {
      if (this.$context.is.mixBuy) {
        return this.mx_increaseTips;
      }

      return '';
    },
  },
};
</script>
